var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4519_117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 20,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9299 4.26904H10.1706C6.62659 4.26904 4.85409 4.26904 3.75356 5.37051C2.96035 6.16278 2.73855 7.30372 2.67653 9.20309H21.424C21.362 7.30372 21.1402 6.16278 20.347 5.37051C19.2465 4.26904 17.474 4.26904 13.9299 4.26904ZM10.1706 19.3062H13.9299C17.474 19.3062 19.2465 19.3062 20.347 18.2047C21.4475 17.1032 21.4485 15.3317 21.4485 11.7876C21.4485 11.3728 21.4478 10.9812 21.4466 10.6128H2.65397C2.65209 10.9812 2.65146 11.3728 2.65209 11.7876C2.65209 15.3317 2.65209 17.1042 3.75356 18.2047C4.85503 19.3052 6.62659 19.3062 10.1706 19.3062Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70654 15.5469C5.70654 15.36 5.78081 15.1807 5.91299 15.0485C6.04518 14.9163 6.22447 14.842 6.41141 14.842H10.1707C10.3576 14.842 10.5369 14.9163 10.6691 15.0485C10.8013 15.1807 10.8755 15.36 10.8755 15.5469C10.8755 15.7338 10.8013 15.9131 10.6691 16.0453C10.5369 16.1775 10.3576 16.2518 10.1707 16.2518H6.41141C6.22447 16.2518 6.04518 16.1775 5.91299 16.0453C5.78081 15.9131 5.70654 15.7338 5.70654 15.5469ZM11.8154 15.5469C11.8154 15.36 11.8896 15.1807 12.0218 15.0485C12.154 14.9163 12.3333 14.842 12.5202 14.842H13.93C14.1169 14.842 14.2962 14.9163 14.4284 15.0485C14.5606 15.1807 14.6348 15.36 14.6348 15.5469C14.6348 15.7338 14.5606 15.9131 14.4284 16.0453C14.2962 16.1775 14.1169 16.2518 13.93 16.2518H12.5202C12.3333 16.2518 12.154 16.1775 12.0218 16.0453C11.8896 15.9131 11.8154 15.7338 11.8154 15.5469Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4519_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.772461 0.509766H23.3281V23.0654H0.772461V0.509766Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.c42a8d1ae8006d7232d0f43f1f6591d4.svg";
export { ForwardRef as ReactComponent };